import { Component, ElementRef, inject, OnDestroy, OnInit, Signal, ViewChild } from '@angular/core';
import { EventTitleComponent } from './event-title/event-title.component';
import { ButtonColors } from '../../../models/enums/components/Button/ButtonColor.enum';
import { ButtonType } from '../../../models/enums/components/Button/ButtonType.enum';
import { NavigationComponent } from './navigation/navigation.component';
import { MenuComponent } from './menu/menu.component';
import { NeighborsComponent } from './neighbors/neighbors.component';
import { LegendComponent } from './legend/legend.component';
import { FullscreenToggleComponent } from "./fullscreen-toggle/fullscreen-toggle.component";
import { HyperlinkComponent } from './hyperlink/hyperlink.component';
import { DvmService } from '@services/dvm.service';
import { Subscription } from 'rxjs';
import { Viewer3dService } from '@3ddv/ngx-dvm-internal';
import anime from 'animejs';
import { BenefitsComponent } from './benefits/benefits.component';
import { LayoutService } from '@services/layout.service';
import { ActionButtonsComponent } from "../footer/action-buttons/action-buttons.component";


@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [
    NavigationComponent,
    MenuComponent,
    EventTitleComponent,
    NeighborsComponent,
    BenefitsComponent,
    LegendComponent,
    HyperlinkComponent,
    FullscreenToggleComponent,
    ActionButtonsComponent
],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.css'
})
export class TopbarComponent implements OnInit, OnDestroy {

  // VIEWCHILDS
  @ViewChild('topbarContainer', {static: true}) 
  private readonly topbarContainer!: ElementRef<HTMLElement>

  // SERVICES
  private readonly dvmService:       DvmService      = inject(DvmService);

  // COMPONENT STATE
  public  readonly isMobile:         Signal<boolean> = inject(LayoutService).isMobile;
  private readonly susbcriptions:    Subscription[]  = [];

  // LIFECYCLE HOOKS
  ngOnInit(): void {
    this.initComponent();
  };

  ngOnDestroy(): void {
    this.destroyComponent();
  }


  // METHODS
  private initComponent(): void {

    const viewer3d: Viewer3dService = this.dvmService.viewer3d;

    viewer3d.waitInitialize().subscribe((): void => this.initSuscriptions());

  }

  private initSuscriptions(): void {

    const viewer3d: Viewer3dService = this.dvmService.viewer3d;

    this.susbcriptions.push(
      viewer3d.getObservable('fullscreen_enabled').subscribe((): void  => this.toggleVisibility(false)),
      viewer3d.getObservable('fullscreen_disabled').subscribe((): void => this.toggleVisibility(true)),
    )

  }

  private destroyComponent(): void {
    this.susbcriptions.forEach((subscription: Subscription): void => subscription.unsubscribe());
  }

  private toggleVisibility(show: boolean): void {
    
    anime({
      targets: this.getVisibilityElements(),
      opacity: show ? 1 : 0,
      easing: 'easeInOutQuad',
      duration: 300,
    })

  }

  private getVisibilityElements(): HTMLElement[] {
        
    // Los 3 elementos hijos del navbar (Search/Menu, EventTitle/Neighbors, Dynamic Buttons)
    const navbarChildrenElements:   HTMLElement[] = Array.from(this.topbarContainer.nativeElement.children) as HTMLElement[],
        // Selector del componente de fullscreen toggle        
        toggleFullscreenSelector:   string        = 'app-fullscreen-toggle',        
        // Elementos fijos del navbar (Search/Menu, EventTitle/Neighbors)                                                                 
        fixedElements:              HTMLElement[] = [navbarChildrenElements[0], navbarChildrenElements[1]],                             
        // Filtramos los children del último elemento de la navbar exluyendo el toggle fullscreen y cogemos el primer child (no el host element)
        dynamicElements:            HTMLElement[] = Array.from(navbarChildrenElements[2].children).filter((element: Element)=> element.tagName.toLowerCase() !== toggleFullscreenSelector).map(el => el.firstChild as HTMLElement) as HTMLElement[];
         
    // Retornamos fixed elements y dynamic elements filtrados:
    return [...fixedElements, ...dynamicElements];

  }



  // TEMP
  // BUTTONS
  colors = ButtonColors;
  type   = ButtonType;

}
